var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationPinOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#location-pin-outlined_svg__clip0_239_7772)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25A4.24 4.24 0 005 0C3.875 0 2.8.45 2 1.25c-.8.8-1.25 1.85-1.25 3 0 2.275 2.175 4.175 3.35 5.2.15.15.3.275.425.375.15.125.325.2.5.2s.35-.075.5-.2c.1-.1.25-.225.425-.375 1.125-1.025 3.3-2.925 3.3-5.225C9.25 3.1 8.8 2.05 8 1.25zM5.525 9c-.175.15-.3.275-.425.375-.05.05-.15.05-.2 0-.125-.1-.25-.225-.425-.375-1.1-.975-3.125-2.75-3.125-4.775 0-2 1.65-3.65 3.65-3.65a3.638 3.638 0 013.65 3.65c0 2.025-2.025 3.8-3.125 4.775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.125 2.25C4.1 2.25 3.25 3.1 3.25 4.125S4.1 6 5.125 6 7 5.15 7 4.125 6.15 2.25 5.125 2.25zm0 3.15A1.28 1.28 0 013.85 4.125c0-.7.575-1.275 1.275-1.275S6.4 3.425 6.4 4.125 5.825 5.4 5.125 5.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "location-pin-outlined_svg__clip0_239_7772"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
}

export default SvgLocationPinOutlined;